module.exports = "//static.hsappstatic.net/salesImages/static-1.403/sidekick/template-onboarding-mole.svg"